/**
 * «Выгодные зоны PRO» — сборка счёта из частей.
 *
 * Здесь собирается ровно то, что рисуется отметкой на графике: зоны,
 * карта ликвидности, ранги старших таймфреймов и производные ряды
 * сводятся в один счёт. График зовёт эту функцию, чтобы нарисовать
 * отметку; сервер — чтобы решить, слать ли уведомление. Функция одна,
 * и разойтись им негде.
 *
 * Что остаётся снаружи: откуда взялись ряды. Терминал берёт их у своего
 * контекста и дописывает живой бар с графика, сервер — из хранилища на
 * момент закрытия свечи. Это разные задачи, и общего в них нет.
 */
import { liquidityMap, resample, stepOf } from './liquidity.js';
import { timeframeRankFrames, zoneSeries } from './zones.js';
import { alignRanks, signalState } from './zone-signals.js';
/**
 * Сколько баров нужно расчёту.
 *
 * Зона строится по окну выборки, и на более коротком ряду её просто
 * нет — вместе с ней нет и сигналов. Молчание из-за нехватки истории
 * выглядит как поломка, поэтому число названо, а не подразумевается.
 */
export const ZONES_PRO_BARS = 600;
/*
 * Память на один разбор.
 *
 * График перерисовывается на каждом кадре и зовёт разбор по тому же
 * ряду, а карта ликвидности по шестистам барам — не та работа, которую
 * делают шестьдесят раз в секунду. Ключ — ссылка на массив: новый ряд
 * приходит новым массивом, и подмена остаётся незамеченной только для
 * того, кто ряд не менял.
 */
let last = null;
export function zonesProAnalysis(candles, shape) {
    const key = `${shape.levels}|${shape.age}`;
    if (last && last.candles === candles && last.key === key)
        return last;
    const analysis = {
        candles,
        zones: zoneSeries(candles),
        levels: liquidityMap(candles, { levels: shape.levels, age: shape.age }),
    };
    last = { ...analysis, key };
    return analysis;
}
/**
 * Счёт и отметки по ряду.
 *
 * Отметки идут рядом целиком, а не одной последней: на графике нужна
 * история, а серверу — та, что пришлась на закрывшийся бар. Выбирать из
 * общего списка честнее, чем считать по-разному.
 */
export function zonesProState(input, options, shape = { levels: 400, age: 2500 }) {
    const step = stepOf(input.candles);
    const { zones, levels } = zonesProAnalysis(input.candles, shape);
    return signalState({
        candles: input.candles,
        zones,
        levels,
        /*
         * Ранги идут рядами, а не последними числами: метка на прошлом
         * баре, посчитанная по сегодняшнему рангу, была бы взглядом в
         * будущее.
         */
        rankSeries: alignRanks(input.candles, step, timeframeRankFrames(input.candles, step, resample, input.frame)),
        step,
        openInterest: input.openInterest,
        premium: input.premium,
        funding: input.funding,
        usdtd: input.usdtd,
        livePartial: input.livePartial,
    }, options);
}
//# sourceMappingURL=zones-pro.js.map